AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "Section");

AoPS.Ebooks.Models.Section = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var EbkMBase = AoPS.Ebooks.Models.Base;
	var EbkMBaseSection = AoPS.Ebooks.Models.BaseSection;

	return EbkMBaseSection.extend({
		// See EbkModels.BaseSection for basic attributes
		/** Additional attributes:
			book: Book model owning this one; guaranteed to be set
			chapter: Chapter model owning this one
		*/

		requestLoad: function (callback, context) {
			this.get("book").requestSectionContent(this.id, callback, context);
		},

		reload: function (callback, context) {
			if (this.get("html")) {
				callback = LoadUtils.makeCallback(callback, context);
				this.loadContent(true, callback);
			}
		},

		loadContent: function (rerender, callback) {
			var book = this.get("book");
			EbkMBase.ajax.run(
				"load_section",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					section_id: this.id,
					rerender: rerender ? 1 : 0,
				},
				function (ok, data) {
					if (!ok) {
						// No sections are created without being sent from server, so we
						// don't need to remove nonexistent ones from parents.
						return callback(ok, data);
					}
					book.unpack(data.response.book);
					callback(ok, {});
				},
				{no_filter: true}
			);
		},

		markViewed: function () {
			var book = this.get("book");
			EbkMBase.ajax.run(
				"mark_section_viewed",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					section_id: this.id,
				},
				function () {}
			);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			var book = this.get("book");

			this.setFields(data);
			this.set("is_hard", !!data.is_hard);

			if (data.hasOwnProperty("chapter_id")) {
				this.set("chapter", book.get("chapters").getOrCreate(data.chapter_id));
				this.get("chapter").get("sections").add(this);
			}

			if (data.html) {
				book.markSectionAsLoaded(this.id);
			}
		},

		getRelativeSectionId: function (type, direction) {
			var sections = this.get("book").get("sections");
			var previous = sections.get(this.get("previous_id"));
			var next = sections.get(this.get("next_id"));

			if (type === "chapter") {
				return this.get("chapter").getRelativeSectionId(direction);
			} else if (direction < 0 && previous) {
				return previous.id;
			} else if (direction > 0 && next) {
				return next.id;
			} else if (direction === 0) {
				return this.id;
			}
		},

		getOrCreateProblem: function (problem_id) {
			return this.get("book").get("problems").getOrCreate(problem_id);
		},

		getOrCreateHint: function (hint_id) {
			return this.get("book").get("hints").getOrCreate(hint_id);
		},

		getTags: function () {
			var parent_tags = this.get("chapter").getTags();
			var number = this.get("number");
			var new_tag = number ? "Section " + number : this.get("title_html");

			// Special cases

			if (new_tag === "Review Problems" || new_tag === "Challenge Problems") {
				new_tag =
					"Chapter " + this.get("chapter").get("number") + " " + new_tag;
			}

			if (parent_tags[0] === "Book") {
				new_tag = "Book " + new_tag;
			}

			return parent_tags.concat([new_tag]);
		},

		// Available options:
		//   full: set to true to show a full title, e.g. "Section X.X: TITLE"
		//     instead of "X.X TITLE"
		//   unique: set to true to show enough info to make this title unique
		//     within the book, e.g. "Ch.2 Challenge Problems" instead of
		//     "Challenge Problems".
		//   plain: set to true to return plain text, with no HTML.
		getNumberTitle: function (options) {
			options = options || {};
			var chapter_number = this.get("chapter").get("number");
			var number = this.get("number");
			var hard =
				this.get("is_hard") && !options.plain ? EbkMBase.HARD_HTML : "";
			var prefix;

			if (options.full && number) {
				prefix = "Section " + number + hard + ":";
			} else if (number) {
				prefix = number + hard;
			} else if (options.unique && chapter_number) {
				prefix = "Ch." + chapter_number + hard;
			} else {
				prefix = hard;
			}

			return prefix + (prefix.length ? " " : "") + this.get("title_html");
		},

		getAlcumusUrl: function () {
			var subject_id = this.get("alcumus_subject_id");
			var topic_id = this.get("alcumus_topic_id");
			if (!subject_id || !topic_id) {
				return;
			}

			return "/alcumus/set_focus/" + subject_id + "/subject/" + topic_id;
		},

		getFeedData: function (url_table) {
			var book = this.get("book");
			var tags = this.getTags();

			if (book.getFirstSectionId() === this.id) {
				tags = book.getTags();
				return {
					main_url: tags[0] || "",
					subtitle: book.get("title"),
					category_id: book.get("cmty_category_id"),
					tags: tags,
				};
			}

			return {
				main_url: url_table.getUrl("section", this.get("fragment_code")),
				subtitle: this.getNumberTitle({unique: true}),
				category_id: book.get("cmty_category_id"),
				tags: tags,
			};
		},
	});
})();
